<template>
  <section>
  <EditarRegistro/>
    <v-card>
      <v-card-text class="grey lighten-2 text--info">
        <v-layout wrap>
          <v-flex class="px-3">
            <v-btn
              icon
              color="primary"
              :to="`/registro-manual-asistencia/listado/${esUsuario}/`"
            >
              <v-icon>arrow_back</v-icon>
            </v-btn>
           
            <strong> 
              Crear solicitud de nuevo registro de asistencia manual
            </strong>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text>
          <v-form @submit.prevent="save()" v-model="valid" ref="form" lazy-validation>
          <v-container grid-list-md>
             <v-layout> 
                <v-flex md4 >
               <v-text-field
                  type="date"
                  v-model="form.fecha_desde"
                  label="Fecha inicio"
               
                  :rules="$validate(['required'])"
                  required
                />
              </v-flex>
         
              <v-flex md4 >
                <v-text-field
                  type="date"
                  v-model="form.fecha_hasta"
                  label="Fecha fin"
                
                  :rules="$validate(['required'])"
                  required
                />
              </v-flex>
            </v-layout>

            <v-layout>
               <v-flex md4 >
                <v-text-field
                  type="time"
                  label="Hora ingreso mañana :"
                 
                  v-model="form.hora_ingreso_mañana"
                />
              </v-flex>
              
               <v-flex md4 >
                <v-text-field
                  type="time"
                  label="Hora salida mañana"
                  
                  v-model="form.hora_salida_mañana"
               />
              </v-flex>
            </v-layout>
              <v-layout>
               <v-flex md4 >
                <v-text-field
                  type="time"
                  label="Hora ingreso tarde :"
                  
                  v-model="form.hora_ingreso_tarde"
                />
              </v-flex>
              
               <v-flex md4 >
                <v-text-field
                  type="time"
                  label="Hora salida tarde"
                  
                  v-model="form.hora_salida_tarde"
               />
              </v-flex>
            </v-layout>
                     <!-- para adjuntos obligatorios-->
            <p>
              Respaldo
            </p>
            <v-layout>   
              <v-flex
                md12
                 >
                <input
                  type="file"
                  @change="handleFileUpload2()"
                  ref="file"
                  accept="application/pdf"
                  :rules="$validate(['required'])"
                  required
                />
                <p class="red--text body-1" v-if="errors2.file">
                  *Debe seleccionar un archivo
                </p>

                <p class="red--text body-1" v-if="errors2.denied">
                  *Formato no admitido por el sistema
                </p>
              </v-flex>
            </v-layout>

             <v-layout>
              <v-flex md4>
                <v-spacer></v-spacer>
                <!-- para crear nuevo -->
                <v-btn color="success" v-if="habilitar_btn==false" block type="submit" :disabled="!valid">
                  <v-icon>arrow_downward</v-icon>
                  Registrar
                </v-btn>
                 
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
          	<!-- Cuerpo del formulario -->
			<v-form
				v-model="valid"
				lazy-validation
				>
				   <v-card-text>
      <v-container>
        <h3 v-if="permiso_detalles!=null && habilitar_btn==true"><strong>Detalles de papeleta</strong></h3>
          
        	<v-data-table
									:items="permiso_detalles"
									class="elevation-1"
									hide-actions
									:headers="headers"
									
									>
									<template v-slot:items="props">
										<td class="text-xs-center"
										>
										{{ props.item.fecha}}
										</td>
										<td class="text-xs-center">
										{{ props.item.ingreso_am}}
										</td>
								
										<td class="text-xs-center">{{ props.item.salida_am }}</td>
										<td class="text-xs-center">{{ props.item.ingreso_pm }}</td>
										 	<td class="text-xs-center">{{ props.item.salida_pm }}</td> 
										  <td class="text-xs-center">{{ props.item.estado_detalle }}</td> 
                       <td>
                 <v-btn
                                color="primary"
                                icon
                                title="Modificar registro"
                                @click.prevent="editarRegistro(props.item)"
                                >
                                    <v-icon>edit</v-icon>
                                </v-btn>
          
                                <v-btn
                                   v-if="(props.item.id_estado_detalle==22 || props.item.id_estado_detalle==7 ||props.item.id_estado_detalle==16)"
                                color="error"
                                icon
                                title="Eliminar registro"
                                @click.prevent="eliminarRegistro(props.item,9)"
                                >
                                    <v-icon>delete</v-icon>
                                </v-btn>

                                 <v-btn
                                v-if="(props.item.id_estado_detalle==9)"
                                color="warning"
                                icon
                                title="Habilitar registro"
                                @click.prevent="eliminarRegistro(props.item,22)"
                                >
                                    <v-icon>done</v-icon>
                                </v-btn>
            </td>
									</template>
          </v-data-table>
		
          </v-container>
      </v-card-text> 
				<v-card-actions>
          <small class="error--text text-required">* Los campos son obligatorios</small>
					<v-spacer></v-spacer>
					<v-btn
						:to="`/registro-manual-asistencia/listado/${esUsuario}/`"
              >
						<v-icon>cancel</v-icon>CERRAR
					</v-btn>
					<!--<v-btn
						color="primary"
						type="submit"
						:loading="loading"
						:disabled="!valid">
						<v-icon dark>check</v-icon> {{$t('common.save') }}
					</v-btn>-->
				</v-card-actions>
	
        </v-form>
      </v-card-text>  
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue";
import crud from "@/common/util/crud-table/mixins/crud-table";
import validate from "@/common/mixins/validate";
import EditarRegistro from "./dialogs/EditarRegistro";

export default {
  components: {},
  mixins: [validate, crud],
  //mixins: [crud],
  data() {
    return {
      habilitar_btn:false,
      id_cabecera:0,
      url: "vAsistenciaManualDetalles", 
      id_cabecera:null,
      form: {},
      valid: false,
      validated: 0,
       graphql: true, 
      /*permiso_detalles:[{
        id:2000,id_permiso:20,fecha:"20-06-2022", ingreso_am:"08:30", ingreso_pm:"12:30", salida_am:"12:30", salida_pm:"16:30",estado:"activo",id_estado:22},
        {id:2001,id_permiso:20,fecha:"20-06-2022", ingreso_am:"08:30", ingreso_pm:"12:30", salida_am:"12:30", salida_pm:"16:30",estado:"inactivo",id_estado:9},
        {id:2002,id_permiso:20,fecha:"20-06-2022", ingreso_am:"08:30", ingreso_pm:"12:30", salida_am:"12:30", salida_pm:"16:30",estado:"activo",id_estado:22},
        {id:2003,id_permiso:20,fecha:"20-06-2022", ingreso_am:"08:30", ingreso_pm:"12:30", salida_am:"12:30", salida_pm:"16:30",estado:"activo",id_estado:22},
        ],*/
        permiso_detalles:[],
          esUsuario: this.$route.params.id,
      errors: {
        denied: false,
      },
      errors2: {
        file: false,

        denied: false,
      },
      loading: false,
      fecha_resultante: "",
      rol: [],
      file: "",
      dataGraphql: `
        id_persona
        ingreso_am
        ingreso_pm
        id_estado_detalle
        id_estado_cabecera
        fecha
        salida_am
        salida_pm
        ruta
        estado_detalle
        estado_cabecera
         id_detalle
      id_cabecera
      autoridad
      `,
      filters: [
        
       /* {
          field: "nombre",
          label: "Nombres",
          type: "text",
          typeG: "String",
        },
        
        {
          field: "item",
          label: "Ítem",
          type: "number",
          typeG: "String",
        },*/
       
      ],
      initData: [
       {
          state: true,
          param: "id_cabecera",
          value: parseInt(this.id_cabecera),
        },
      ],
          headers: [
        {
          text: "Fecha",
          sortable: false
        },
        {
          text: "Hora ingreso mañana",
          sortable: false
        },
        {
          text: "Hora salida mañana",
          sortable: false
        },
       {
          text: "Hora ingreso tarde",
          sortable: false
        },
        {
          text: "Hora salida tarde",
          sortable: false
        },
          {
          text: "Estado",
          sortable: false
        },
        {
          text: "Acciones",
          sortable: false
        }
      ],
    };
  },
   mounted() {
       this.getPersonaId();
       //this.cargarDetallesRegistro();
       this.$bus.$on('closeDialog', async() => {
       await this.cargarDetallesRegistro(this.id_cabecera)
    })
  },
  methods: {
    async eliminarRegistro(item,id_estado){
        this.$confirm("Esta seguro de deshabilitar el registro?", async() => {
       
        let respuesta 
        let id_funcionario=parseInt(this.$storage.get("user").id_persona)
        let fecha = this.$moment(new Date()).format("YYYY-MM-DD");
        let consulta=`SELECT control.fn_anula_asistencia_manual_detalle(${parseInt(item.id_detalle)},${id_estado},${id_funcionario},'${fecha}')`
        try {
        respuesta = await this.$service.graphql({
        query: `
        query{
        runQuery(consulta:"${consulta}"){
        respuesta
        }
        }
        `,
        });
        respuesta = respuesta.runQuery.respuesta[0].fn_anula_asistencia_manual_detalle;
        let resps = respuesta.split("|");
        let correcto = resps[0];
        if (correcto === "1") {
          if(id_estado==9){ this.$message.success("Anulación exitosa.");}
          else{ this.$message.success("Habilitacion exitosa.");}
       
          await this.cargarDetallesRegistro(this.id_cabecera)
        } 
        else {
        this.$message.error(resps[1]);
        }
        } catch (error) {
        console.log(error);
        }

        });
        },
     async cargarDetallesRegistro(id_cabecera){
       try {
          let respuesta = await this.$service.graphql({
              query: `
               query{
                vAsistenciaManualDetalles(id_cabecera:${parseInt(id_cabecera)}){
                  rows{
                    id_persona
                    ingreso_am
                    ingreso_pm
                    id_estado_detalle
                    id_estado_cabecera
                    fecha
                    salida_am
                    salida_pm
                    ruta
                    estado_detalle
                    estado_cabecera
                  id_detalle
                    id_cabecera
                    autoridad
                  }
                }
              }
                `,
            });
         
         this.permiso_detalles = respuesta.vAsistenciaManualDetalles.rows
       } catch (error) {
         console.log(error)
       }
     },
      async editarRegistro(item) {
      this.$bus.$emit("openDialogEditarRegistro", item);
      await this.cargarDetallesRegistro(item.id_cabecera);
    },
      async saveFile(){

      },
      eliminarDetalle(){

      },
    getPersonaId() {
     let id_usuario=parseInt(this.$route.params.id)
      return id_usuario;
    },
  
    handleFileUpload() {
      if (this.$refs.file.value !== "") {
        const file = this.$refs.file.files[0];
        if (this.$refs.file.files[0].type.includes("application/pdf")) {
          this.errors.denied = false;
        } else {
          this.errors.denied = true;
        }
        this.file = file;
      }
    },
    handleFileUpload2() {
    
      if (this.$refs.file.value !== "") {
        const file = this.$refs.file.files[0];

        if (this.$refs.file.value === "") {
          this.errors2.file = true;
        } else {
          this.errors2.file = false;
        }
        if (this.$refs.file.files[0].type.includes("application/pdf")) {
          this.errors2.denied = false;
        } else {
          this.errors2.denied = true;
        }
        this.file = file;
        this.form.ruta_archivo=undefined
      }
    },
    
    async save () {
			if (this.$refs.form.validate()) {
        let correcto
        if (this.form.hora_ingreso_mañana || this.form.hora_ingreso_tarde || this.form.hora_salida_mañana || this.form.hora_salida_tarde) {
          this.loading = true
          
        let respuesta;
                let fecha = this.$moment(new Date()).format("YYYY-MM-DD");
                 const user = this.$storage.get("user");
                let resps = [];
               
                    if (this.$refs.file.value === "") {
                    this.errors2.file = true;
                    return this.errors2;
                    } else {
                    this.errors2.file = false;
                    }
                    if (this.errors2.denied) {
                    return this.errors2;
                    }
                    //obtener ruta del archivo
                      if(this.$refs.file.value !== "" && this.form.ruta_archivo==undefined){
                        let formData = new FormData();
                        formData.append("file", this.file);
                        let res = await this.$http.post(
                        process.env.API_URL + "public/upload",
                        formData
                        );
                        this.form.ruta_archivo = res.data;
                      }
                        if(this.form.hora_ingreso_mañana==undefined || !this.form.hora_ingreso_mañana){this.form.hora_ingreso_mañana='00:00'}
                           if(this.form.hora_salida_mañana==undefined || !this.form.hora_salida_mañana){this.form.hora_salida_mañana='00:00'}
                              if(this.form.hora_ingreso_tarde==undefined || !this.form.hora_ingreso_tarde){this.form.hora_ingreso_tarde='00:00'}
                                 if(this.form.hora_salida_tarde==undefined || !this.form.hora_salida_tarde){this.form.hora_salida_tarde='00:00'}
                  //registrar 
                  try {
                    let fecha_actual = this.$moment(new Date()).format("YYYY/MM/DD");
                    respuesta = await this.$service.graphql({
                      query: `
                                    query{
                                      runQuery(consulta:"select control.fn_registra_asistencia_manual('${fecha_actual}',${parseInt(this.getPersonaId())},'${this.form.hora_ingreso_mañana}','${this.form.hora_salida_mañana}','${this.form.hora_ingreso_tarde}','${this.form.hora_salida_tarde}','${this.form.fecha_desde}','${this.form.fecha_hasta}',${user.id},'${this.form.ruta_archivo}',2)"){
                                        respuesta
                                      }
                                    }
                                  `,
                    });
                    console.log(fecha_actual,parseInt('select control.fn_registra_asistencia_manual',this.getPersonaId()),this.form.hora_ingreso_mañana,this.form.hora_salida_mañana,this.form.hora_ingreso_tarde,this.form.hora_salida_tarde,this.form.fecha_desde,this.form.fecha_hasta,user.id,this.form.ruta_archivo,2);
                  } catch (error) {
                    console.log(error);
                  }
                  try {
                    respuesta =
                    respuesta.runQuery.respuesta[0].fn_registra_asistencia_manual;
                    resps = respuesta.split("|");
                    correcto = resps[0];

                    if (correcto === "1") {
                      this.id_cabecera=resps[1]
                  
                      await this.cargarDetallesRegistro(this.id_cabecera);
                       this.habilitar_btn=true;
                       this.id_cabecera= resps[1]
                       console.log(this.id_cabecera,"id del permiso")
                      this.$confirm("Registro exitoso", () => {});
                       this.$router.push("/registro-manual-asistencia/modificar/"+this.esUsuario+"/"+this.id_cabecera);
                      //registro-manual-asistencia/modificar/2973/158
                    } else {
                      this.$confirm(resps[1], () => {});
                    }
                  } catch (error) {
                    console.log(error);
                  }

               this.loading = false
                this.file = "";
               // this.$router.push("/permisos/usuario/");  
        } else {
           this.$confirm("Debe ingresar al menos una hora", () => {});
        }
				
			}
		}
    
  },
  components: {
      EditarRegistro,
       CrudTable,
  },
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/admin/registro_manual_asistencia/CrearRegistroAsistenciaManual.vue